export default class FormatUtils {
  public static buildRangeDescription(min, suffixMin, max, suffixMax) {
    if (!min && !max) {
      return 'qualquer';
    }
    if (!max) {
      return 'a partir de ' + min + ' ' + suffixMin;
    }
    if (!min) {
      return 'até ' + max + ' ' + suffixMax;
    }
    return 'de ' + min + (suffixMin != suffixMax ? ' ' + suffixMin : '') + ' até ' + max + ' ' + suffixMax;
  }
}
